const isProd = import.meta.env.MODE === "production";
const defaultApiBase = isProd
   ? "https://backend.properteasy.bitbenders.com"
   : "http://localhost:8002";
const apiBase = (import.meta.env.VITE_API_BASE || defaultApiBase).replace(/\/$/, "");

const APPLICATION_SETTINGS = {
   REDIRECT_TO_POST_SIGNUP_THANK_YOU_ON_LOGIN: false,
   DJANGO_API_URL: (import.meta.env.VITE_DJANGO_API_URL || `${apiBase}/api`).replace(/\/$/, ""),
   VITE_API_BASE: apiBase,
   //STRIPE_API_KEY: "pk_test_51RLmcWQYdeX2xe6fFGHcry3JeBqVPKCDVujblWsDeSQ8XyJwXGu21iA9akwUeSzntI6YXHUKKzK9niENQzD4MjsK00QkRSRBuA",
   STRIPE_API_KEY: "pk_live_51RLmcOHBo04kyRBWePCXwRLrYNtVevT1VP5pbdO1KzQtobeWOO08H2GJOjdHcx6yF9loMDD7bUo4zb1fLm2vINcH00dWhh6dlr",

   SENTRY: {
      dsn: "https://88c84142789032ed79e25064861bed2e@o4511351893262336.ingest.us.sentry.io/4511381337538560",
      enabled: isProd,
      environment: import.meta.env.MODE,
      tracesSampleRate: isProd ? 0.1 : 1.0,
      replaysSessionSampleRate: 0.1,
      replaysOnErrorSampleRate: 1.0,
   },
};

export default APPLICATION_SETTINGS;
